import {anOrganisation} from '../../utils/fixtures';
import {documentsInDb} from '../document/FakeDocumentService';

export default class FakeDocumentKpiService {
  getInvalidOrganisationDocumentsByIntervention() {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve({
          organisations: [{
            organisation: anOrganisation(),
            interventionId: 3,
            documents: documentsInDb
          }],
          totalCount: 57
        });
      }, 0);
    });
  }

  getInvalidSubcontractorsDocumentsByOrganisation() {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve({
          organisations: [{
            organisation: anOrganisation(),
            documents: documentsInDb
          }],
          totalCount: 57
        });
      }, 0);
    });
  }

  getValidProjectDossierStatesPercentageByIntervention() {
    return new Promise(resolve => {
      setTimeout(() => resolve(60), 0);
    });
  }

  getValidSubcontractorsDossierStatesPercentageByUser() {
    return new Promise(resolve => {
      setTimeout(() => resolve({
        FRANCE: 60,
        GERMANY: 85
      }), 0);
    });
  }

  getProjectDocumentsPercentageByDocumentStateByIntervention() {
    return new Promise(resolve => {
      setTimeout(() => resolve({
        VALID: 30,
        ALMOST_EXPIRED: 50,
        MISSING: 20
      }), 0);
    });
  }

  getSubcontractorsDocumentsPercentageByDocumentStateByUser() {
    return new Promise(resolve => {
      setTimeout(() => resolve({
        VALID: 15,
        ALMOST_EXPIRED: 35,
        MISSING: 50
      }), 0);
    });
  }

  getValidSubcontractorsDossierStatesPercentageByOrganisation() {
    return new Promise(resolve => {
      setTimeout(() => resolve({
        FRANCE: {VALID: 3, INVALID: 4},
        GERMANY: {VALID: 2, INVALID: 8}
      }), 0);
    });
  }

  getDocumentCountByState() {
    return new Promise(resolve => {
      setTimeout(() => resolve({
        AWAITING_GATHERING: 1,
        AWAITING_SIGNATURE: 1,
        AWAITING_VALIDATION: 14,
        EXPIRED: 6,
        MISSING: 2,
        NOT_APPLICABLE: 1,
        REJECTED: 1,
        SIGNED: 1,
        VALID: 4
      }), 0);
    });
  }
}
